import { render, staticRenderFns } from "./RegisterViaMail.vue?vue&type=template&id=9764ba0a&scoped=true"
import script from "./RegisterViaMail.vue?vue&type=script&lang=js"
export * from "./RegisterViaMail.vue?vue&type=script&lang=js"
import style0 from "./RegisterViaMail.vue?vue&type=style&index=0&id=9764ba0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9764ba0a",
  null
  
)

export default component.exports